var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getOngoingShiftsByMissionIdFunctionDef, } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import useSWRInfinite from 'swr/infinite';
export const ongoingShiftsFetchKey = 'ongoingShifts';
const ongoingShiftsDisplayLimit = 5;
export const useOngoingShifts = ({ missionId }) => {
    var _a, _b, _c, _d;
    const getOngoingShiftsPlatformFn = useTypedPlatformFunction(getOngoingShiftsByMissionIdFunctionDef);
    const fetchOngoingShifts = React.useCallback((params) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield getOngoingShiftsPlatformFn(params);
            return result; // TODO: Remove cast after PLAT-2704
        }
        catch (e) {
            handleErrorSnackbar(e);
            return { rows: [], total: 0 };
        }
    }), [getOngoingShiftsPlatformFn]);
    const getKey = React.useCallback((pageIndex, previousPageData) => {
        if (previousPageData && previousPageData.rows.length === 0)
            return null;
        if (!missionId)
            return null;
        return [ongoingShiftsFetchKey, missionId, pageIndex];
    }, [missionId]);
    const { data, size, setSize, isValidating, mutate } = useSWRInfinite(getKey, (_a) => __awaiter(void 0, [_a], void 0, function* ([, keyMissionId, pageIndex]) {
        const offset = Number(pageIndex) * ongoingShiftsDisplayLimit;
        return fetchOngoingShifts({
            missionId: keyMissionId,
            limit: ongoingShiftsDisplayLimit,
            offset,
        });
    }), Object.assign(Object.assign({}, defaultFetcherOptions), { revalidateFirstPage: true }));
    React.useEffect(() => {
        if (missionId)
            setSize(1);
    }, [missionId, setSize]);
    const flattenedData = React.useMemo(() => (data ? data.flatMap((p) => p.rows) : []), [data]);
    const total = (_b = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.total) !== null && _b !== void 0 ? _b : 0;
    const hasMoreOngoingShifts = flattenedData.length < total && ((_d = (_c = data === null || data === void 0 ? void 0 : data[data.length - 1]) === null || _c === void 0 ? void 0 : _c.rows.length) !== null && _d !== void 0 ? _d : 0) > 0;
    const loadMoreOngoingShifts = React.useCallback(() => {
        if (!hasMoreOngoingShifts)
            return;
        setSize(size + 1);
    }, [hasMoreOngoingShifts, setSize, size]);
    const refetchAll = React.useCallback(() => mutate(), [mutate]);
    return {
        ongoingShifts: { total, rows: flattenedData },
        loadMoreOngoingShifts,
        hasMoreOngoingShifts,
        isValidating,
        refetchAll,
    };
};
